export function addYears(date: string, years: number): string {
	return parseInt(date.slice(0, 4), 10) + years + date.slice(4)
}
